import { Injectable } from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { AlertService } from "../../alert.service";
import { StorageService } from "../../storage.service";
import { ReportTypes } from "../../../reports/models/reports";
import { OfferTypeResponse } from "../../../_models/dashboard";

@Injectable({
  providedIn: "root",
})
export class OrdersOfferTypeService extends DashboardService {
  route = "order_dashboard/performance_by_offer_type";
  protected reportType = ReportTypes.ORDER_RETENTION;
  protected data: BehaviorSubject<OfferTypeResponse> = new BehaviorSubject<OfferTypeResponse>(undefined);

  constructor(
    protected http: HttpClient,
    protected alertService: AlertService,
    protected storageService: StorageService
  ) {
    super(http, alertService, storageService);
  }

}
